import React, { useEffect, useState } from 'react';
import { Container, Card, Spinner } from 'react-bootstrap';
import { useParams, useSearchParams } from 'react-router-dom';
import PayPalWrapper from '../Braintree/PayPalWrapper';
import { t } from 'i18next';
import { SubscriptionService } from '../../Services/Axios/Api';

const SubscriptionPayment = () => {
    const { method } = useParams();
    const [searchParams] = useSearchParams();
    const invoiceId = searchParams.get('invoiceId');
    const [isLoading, setIsLoading] = useState(false);
    const [transaction , setTransaction] = useState({});
   
    const handleCreateOrder = async () => {
        try {
            setIsLoading(true);

            const response = await SubscriptionService.GetInvoiceById(invoiceId);
            setTransaction(response.result)
            const parsedUrl = new URL(response.result.paymentUrl);
            const transactionId = parsedUrl.searchParams.get("token");
            return transactionId;
        } catch (error) {
            console.error('Error creating payment order:', error);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    const handleOnApprove = async (data) => {
        try {
            setIsLoading(true);
            console.log('Payment approved:', data);
            window.location.href = `/callback/PayPal?paymentId=${data.orderID}&payerId=${data.payerID}`;
        } catch (error) {
            console.error('Error processing payment:', error);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    if (!invoiceId) {
        return (
            <Container className="mt-5">
                <Card>
                    <Card.Body>
                        <h3>Invalid Order</h3>
                        <p>No order ID provided.</p>
                    </Card.Body>
                </Card>
            </Container>
        );
    }

    return (
        <Container className="mt-5 mb-5">
            <Card>
                <Card.Body>
                    <h3 className='text-center mb-4'>{t('ChoosePayment')}</h3>                    
                    {isLoading && (
                        <div className="text-center mb-4">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    )}

                    <div className="w-100 ">
                        <PayPalWrapper
                            handleCreateOrder={handleCreateOrder}
                            handleOnApprove={handleOnApprove}
                        />
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default SubscriptionPayment; 